<script lang="ts">
  import { page } from '$app/stores';
  import logo from '$lib/assets/img/logo.svg';
  import { onMount } from 'svelte';

  export let isBetaAvailable: boolean;

  let navbar: HTMLElement;

  function setNavbarHeight() {
    if (navbar) {
      let navbarHeight = navbar.offsetHeight;
      document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`);
    }
  }

  onMount(() => {
    setNavbarHeight();
  });
</script>

<svelte:window on:resize={setNavbarHeight} />

<header>
  <nav class="navbar navbar-expand-lg" bind:this={navbar}>
    <div class="container-fluid">
      <a class="navbar-brand" href="/"><img src={logo} alt="impulso.space logo" /></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              class:active={$page.url.pathname.startsWith('/services/')}
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Services
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="/services/launchCapacity">Launch Capacity</a>
              </li>
              <li>
                <a class="dropdown-item" href="/services/satellitePreparation"
                  >Satellite Preparation</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="/services/launchMissionManagement"
                  >Launch Mission Management</a
                >
              </li>
              <li><a class="dropdown-item" href="/services/storage">Storage</a></li>
              <li><a class="dropdown-item" href="/services/shipment">Shipment</a></li>
              <li>
                <a class="dropdown-item" href="/services/customsClearance">Customs Clearance</a>
              </li>
              <li><a class="dropdown-item" href="/services/insurance">Insurance</a></li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              class:active={$page.url.pathname.startsWith('/company/')}
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Company
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="/company/history">History</a></li>
              <li><a class="dropdown-item" href="/company/facility">Facility</a></li>
              <li><a class="dropdown-item" href="/company/newsRoom">News Room</a></li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              class:active={$page.url.pathname.startsWith('/tools/')}
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Tools
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="/tools/launchSchedule">Launch Schedule</a></li>
              <li><a class="dropdown-item" href="/tools/launchArchive">Launch Archive</a></li>
              <hr class="my-1 mx-3" />
              <li>
                <a class="dropdown-item" href="/tools/operators" data-sveltekit-reload
                  >Operators Statistics</a
                >
              </li>
              <li><a class="dropdown-item" href="/tools/sites">Sites Statistics</a></li>
              {#if isBetaAvailable}
                <li><a class="dropdown-item" href="/tools/payloads">Payloads Statistics</a></li>
              {/if}
              <!-- <hr class="my-1 mx-3" />
              <li><a class="dropdown-item" href="/tools/blog/posts">Blog</a></li> -->
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              class:active={$page.url.pathname.startsWith('/contactUs/')}
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Contact Us
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="/contactUs/reachOut">Reach out</a></li>
              <li>
                <a class="dropdown-item" href="/contactUs/bookYourLaunch">Book Your Launch</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<style>
  .navbar-brand img {
    aspect-ratio: auto 197/32;
    height: 32px;
  }

  .navbar-brand {
    position: absolute;
  }

  .navbar {
    font-size: 17px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    z-index: 1;
  }

  nav {
    border-bottom: 2px solid var(--grey-15);
    background-color: var(--grey-06);
  }

  .nav-item > a:not(.dropdown-item) {
    margin: 0 10px;
  }

  .dropdown-toggle::after {
    font-size: 19px;
    margin-left: 0.355em;
    vertical-align: 0.13em;
  }

  .dropdown-menu {
    background-color: rgb(20, 20, 20);
    border: none;
    --bs-dropdown-link-hover-color: black;
    --bs-dropdown-link-hover-bg: var(--white);
    --bs-dropdown-link-active-color: black;
    --bs-dropdown-link-active-bg: var(--white);
  }

  li .dropdown-item {
    font-size: 16px;
  }

  a.nav-link.active,
  a.nav-link:hover {
    background: linear-gradient(var(--white), var(--white)) no-repeat;
    background-size: 100% 2px;
    background-position: 0 100%;
  }

  @media (max-width: 1400px) {
    #navbarNav {
      justify-content: right !important;
    }

    .nav-item:last-child > .dropdown-menu {
      left: auto;
      right: 0;
    }
  }

  @media (max-width: 1199px) {
    .navbar-brand {
      position: relative;
    }
  }
</style>
